import React from 'react';
import styles from './styles.module.scss';
import icClose from 'assets/svg/ic_close.svg';
import icNotify from 'assets/svg/ic_notify_v2.svg';
import Modal from 'src/Components/Modal';
import Button from '../../Components/Button';

const PreventSellingModal = ({
  onClose
}) => {
  return /*#__PURE__*/React.createElement(Modal, null, /*#__PURE__*/React.createElement("div", {
    className: styles.modal
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.header
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.label
  }), /*#__PURE__*/React.createElement("button", {
    className: styles.close,
    onClick: onClose
  }, /*#__PURE__*/React.createElement("img", {
    src: icClose
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles.detailContainer
  }, /*#__PURE__*/React.createElement("img", {
    className: styles.icon,
    src: icNotify
  }), /*#__PURE__*/React.createElement("span", {
    className: styles.description
  }, "This hero is being played in-game and could not be sold on marketplace"), /*#__PURE__*/React.createElement("div", {
    className: styles.buttonGroup
  }, /*#__PURE__*/React.createElement(Button, {
    title: "I understand",
    onClick: onClose
  })))));
};

export default PreventSellingModal;